Voonto.getInstance().define(['module'], function (module) {
    return {
        wakeUp($elm){
            Logger.info(`wake up module ${module.id}`);
            const app = Voonto.getInstance();

            const outbrainCodes = app.lookup('vocento.config.nibara').outbrainCodes;
            if (outbrainCodes === undefined) {
                throw 'nibara outbrainCodes config is empty';
            }

            let template = 'vocentoes';
            Logger.info('[outbrain] template: '+template);

            // wait to finish document load
            Voonto.$(document).ready(function() {
            Logger.info('[outbrain] DOM load finished continue loading outbrain widgets');

              outbrainCodes.split(',').forEach((widget) => {
                Logger.info('[outbrain] append widget with code: ' + widget);
                $elm.append(`<div class="OUTBRAIN" data-src="${document.URL}" data-widget-id="${widget}" data-ob-template="${template}"></div>`);
              });
              app.load('//widgets.outbrain.com/outbrain.js').then(() => {
                Logger.info('[outbrain] call to outbrain success');
                setTimeout(function () {
                  Logger.info('[Sticky] call to outbrain success');
                  app.trigger('layout:recalc-sticky');
                }, 1000);
              }, (error) => {
                Logger.error('[outbrain] call to outbrain rejected ' + error);
                Logger.info('[Sticky] call to outbrain rejected ' + error);
                app.trigger('layout:recalc-sticky');
              });
            });
        }
    }
});



// WEBPACK FOOTER //
// ./src/modules/outbrain-module.js